import { render } from "./activites.vue?vue&type=template&id=cf4f7160"
import script from "./activites.vue?vue&type=script&lang=ts"
export * from "./activites.vue?vue&type=script&lang=ts"
script.render = render

export default script